import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { isEmpty, noop } from 'lodash';

import {
  injectIntl,
  AddPaymentDetailDialog,
  LightButton,
  ViewPaymentDetailDialog,
} from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { dispatchRestMaker } from 'helpers/utils';
import { buyersPaymentDetailActions } from 'redux/buyers/actions';
import {
  getErrorSelector,
  getRequestingSelector,
} from 'redux/selectors';
import { setHotNotification } from 'redux/ui/actions';

class PaymentInfoButton extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    addPaymentDetailDialogOpen: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired,
    paymentLoading: PropTypes.bool.isRequired,
    paymentError: PropTypes.shape({}).isRequired,
    setHotNotification: PropTypes.func.isRequired,
    createBuyerPaymentDetail: PropTypes.func.isRequired,
    removeBuyerPaymentDetail: PropTypes.func.isRequired,
    updateBuyerPaymentDetail: PropTypes.func.isRequired,
    onAddPaymentDetailDialogClose: PropTypes.func,
  };

  static defaultProps = {
    addPaymentDetailDialogOpen: false,
    onAddPaymentDetailDialogClose: noop,
  };

  state = {
    addPaymentDetailDialogOpen: this.props.addPaymentDetailDialogOpen,
    viewPaymentDetailDialogOpen: false,
    initialPaymentType: 'card',
  };

  componentWillReceiveProps(nextProps) {
    this.setState( {addPaymentDetailDialogOpen: nextProps.addPaymentDetailDialogOpen});
    const { setHotNotification } = this.props;
    // this.checkPermission(nextProps);
    if (this.props.paymentLoading && !nextProps.paymentLoading &&
      isEmpty(nextProps.paymentError) && this.state.addPaymentDetailDialogOpen) {
      this.setState({ addPaymentDetailDialogOpen: false });
      if (this.state.initialPaymentType === 'bank_account') {
        setHotNotification('We sent you 2 small deposit requests through your bank account for verification purpose.\nPlease approve and deposit the requested amount and you are good to go.');
      }
    }
  }

  onAddCard = () => {
    this.setState({
      addPaymentDetailDialogOpen: true,
      initialPaymentType: 'card',
      viewPaymentDetailDialogOpen: false,
    });
  }

  onAddBankAccount = () => this.setState({
    addPaymentDetailDialogOpen: true,
    initialPaymentType: 'bank_account',
    viewPaymentDetailDialogOpen: false,
  });

  setDefaultPaymentSource = source => this.props.updateBuyerPaymentDetail(
    this.context.currentUser.accountId, null, {
      customer: source.customer,
      default_source: source.id,
    },
  )

  submitPaymentToken = (token) => {
    const { currentUser } = this.context;
    const { onAddPaymentDetailDialogClose } = this.props;
    this.props.createBuyerPaymentDetail(currentUser.accountId, { token });
    onAddPaymentDetailDialogClose && onAddPaymentDetailDialogClose();
  }

  deletePaymentSource = (source) => {
    const { setHotNotification } = this.props;
    const { currentUser } = this.context;
    if (currentUser.account.paymentDetail.sources.data.length <= 1) {
      setHotNotification('You should have at least 1 payment source attached.');
      return;
    }
    this.props.removeBuyerPaymentDetail(
      currentUser.accountId, null, {
        customer: source.customer,
        source: source.id,
      },
    );
  }

  toggleAddPaymentDlg = () =>{
    const { onAddPaymentDetailDialogClose } = this.props;
    onAddPaymentDetailDialogClose && onAddPaymentDetailDialogClose();
    this.setState({ addPaymentDetailDialogOpen: !this.state.addPaymentDetailDialogOpen });
  };

  toggleViewPaymentDlg = () =>
    this.setState({ viewPaymentDetailDialogOpen: !this.state.viewPaymentDetailDialogOpen });

  render() {
    const { currentUser } = this.context;
    const { formatMessage, paymentLoading } = this.props;
    const {
      addPaymentDetailDialogOpen,
      viewPaymentDetailDialogOpen,
      initialPaymentType,
    } = this.state;
    const hasPayment = currentUser.id && Boolean(currentUser.account.paymentDetail);

    return (
      <Fragment>
        {
          !hasPayment ?
            <LightButton
              onClick={() => this.toggleAddPaymentDlg()}
            >
              {formatMessage('Payment Method')}
            </LightButton>
          :
            <LightButton
              onClick={() => this.toggleViewPaymentDlg()}
            >
              {formatMessage('Payment Method')}
            </LightButton>
        }
        <AddPaymentDetailDialog
          initialPaymentType={initialPaymentType}
          loading={paymentLoading}
          onClose={this.toggleAddPaymentDlg}
          open={addPaymentDetailDialogOpen}
          submitToken={this.submitPaymentToken}
          title={formatMessage('Add Payment Information')}
        />
        {currentUser.id && (
          <ViewPaymentDetailDialog
            loading={paymentLoading}
            onAddBankAccount={this.onAddBankAccount}
            onAddCard={this.onAddCard}
            onClose={this.toggleViewPaymentDlg}
            onDeletePaymentSource={this.deletePaymentSource}
            onSetDefaultPaymentSource={this.setDefaultPaymentSource}
            open={viewPaymentDetailDialogOpen}
            paymentDetail={currentUser.account.paymentDetail}
            title={formatMessage('Your Payment Information')}
          />
        )}
      </Fragment>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  paymentError: getErrorSelector('buyers', 'buyersPaymentDetail')(state),
  paymentLoading: getRequestingSelector('buyers', 'buyersPaymentDetail')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  ...dispatchRestMaker([
    [buyersPaymentDetailActions, 'buyerPaymentDetail'],
  ])(dispatch),
  setHotNotification: payload => dispatch(setHotNotification(payload)),
});

export default compose(
  setDisplayName('PaymentInfoButton'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  immutableToJS,
  injectIntl,
)(PaymentInfoButton);

